import React from 'react';

export const Conversaciones = () => {
  return <div>Conversaciones</div>;
};
